import { CACHE_LOGO_DATA } from 'constants/localStorageKeys';
import { isValidLogoEntry } from './isValidLogoEntry';

export const getCachedLogoData = (url) => {
    if (!url) {
        return null;
    }
    try {
        const raw = localStorage.getItem(CACHE_LOGO_DATA);
        if (!raw) {
            return null;
        }
        const entry = JSON.parse(raw);
        if (isValidLogoEntry(entry, url)) {
            return entry.dataUrl;
        }

        localStorage.removeItem(CACHE_LOGO_DATA);
    } catch {
        // corrupted cache
    }

    return null;
};
